<div class="comment">
	@if (showTypeHeader()) {
	<h4><span class="icon"><fa-icon [icon]="MessageTypeIcons[type()]?.icon"></fa-icon></span>
		{{( MessageTypes[type()] + 'Title') | translate}}
	</h4>
	}
	<div class="NgxEditor__Wrapper">
		<ngx-editor-menu [editor]="editor" [toolbar]="toolbar"> </ngx-editor-menu>
		<ngx-editor [editor]="editor" [ngModel]="htmlContent()" [disabled]="false" [placeholder]="'Bitte geben Sie einen Text ein' | translate"></ngx-editor>
	  </div>
</div>
